import { TransferAccountDTO } from '../../api/useTransferAccountsOptionsQuery';
import { OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';

export const EXTERNAL_LINK =
  'https://dtcclearning.com/products-and-services/equities-clearing/automated-customer-account-transfer-service-acats.html';

export enum TransferAccountStep {
  TransferAccount = 'transferAccount',
  TransferAccountConfirmType = 'transferAccountConfirmType',
  TransferAccountConfirmNumber = 'transferAccountConfirmNumber',
  PlaidModalVisible = 'plaidModalVisible',
}

export type SelectOptionType = OptionType<TransferAccountDTO>;
